<template>
    <div class="hiq-event-view__heading">
        <h1 class="hiq-event-view__heading--title">{{event.title}}</h1>
        <div class="hiq-event-view__heading--info" :class="isVisitSite ? 'visit' : ''">
            <div class="hiq-event-view__heading--info__date" :style="backgroundColor" v-html="getDates(event.info.start, event.info.end)"></div>
            <div class="hiq-event-view__heading--info__time"><span :style="accentColor" class="hiq-event-view__heading--info__time--icon"></span>{{getTime(event.info.start, event.info.end)}}</div>
            <a class="hiq-event-view__heading--info__location" v-if="event.info.location" :href="event.info.location.link" :style="accentColor"><span :style="accentColor" class="hiq-event-view__heading--info__location--icon"></span><span class="hiq-event-view__heading--info__location--text">{{event.info.location.name}}</span></a>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

var locale = document.documentElement.lang;
moment.locale(locale);


export default {
    name:'heading',
    computed: {
        event() { return this.$store.state.event; },
        backgroundColor() { 
            console.log(this.$store.state);
            var styleString = this.$store.getters.accentBackgroundColor;
            if(this.$store.state.isVisitSite){
                styleString += ' color:#FFFFFF';
            } else {
                styleString += ' color:#000';
            }
            return styleString; 
        },
        accentColor() { return this.$store.getters.accentColor; },
        isVisitSite() { return this.$store.state.isVisitSite; }
    },
    methods: {
        getDates(start, end){
            var formattedDate = '';
            var startDate = moment(start);
            var endDate = moment(end);
            formattedDate = startDate.format('DD MMM');
            if(!startDate.isSame(endDate, 'day')){
                formattedDate += ' - ' + endDate.format('DD MMM');
            }
            return formattedDate;
        },
        getTime(start, end){
            var time = moment(start).format('HH.mm');
            if(moment(start).isSame(moment(end), 'minute')){
                return time;
            }
            var endTime = moment(end).format('HH.mm'); 
            time += ' - ' + endTime;
            return time;
        }
    }
}
</script>
